export enum FrontendConsoleType {
    LOG = 'LOG',
    WARN = 'WARN',
    ERROR = 'ERROR',
}